import api from './api';

// جلب جميع التقييمات (للوحة التحكم)
export const getReviews = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/reviews/admin/all?${queryParams}`);
  return response.data;
};

// جلب تقييمات عنصر معين (خدمة، سائق، إلخ)
export const getReviewsByTarget = async (targetType, targetId, params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/reviews/${targetType}/${targetId}?${queryParams}`);
  return response.data;
};

// الموافقة على تقييم
export const approveReview = async (id) => {
  const response = await api.put(`/reviews/${id}/approve`);
  return response.data;
};

// الرد على تقييم
export const replyToReview = async (id, reply) => {
  const response = await api.put(`/reviews/${id}/reply`, { reply });
  return response.data;
};

// حذف تقييم
export const deleteReview = async (id) => {
  const response = await api.delete(`/reviews/${id}`);
  return response.data;
};

// إضافة تقييم جديد (من العميل)
export const addReview = async (data) => {
  const response = await api.post('/reviews', data);
  return response.data;
};
